function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export function getClones(_ref) {
  var clonesCountHead = _ref.clonesCountHead,
      clonesCountTail = _ref.clonesCountTail,
      particlesContainerChildren = _ref.particlesContainerChildren;
  // TODO: add fns to remove clones if needed
  var clonesToAppend = [];

  for (var i = 0; i < clonesCountTail; i++) {
    clonesToAppend.push(particlesContainerChildren[i].cloneNode(true));
  }

  var clonesToPrepend = [];
  var len = particlesContainerChildren.length;

  for (var _i = len - 1; _i > len - 1 - clonesCountHead; _i--) {
    clonesToPrepend.push(particlesContainerChildren[_i].cloneNode(true));
  }

  return {
    clonesToAppend: clonesToAppend,
    clonesToPrepend: clonesToPrepend
  };
}
export function applyClones(_ref2) {
  var particlesContainer = _ref2.particlesContainer,
      clonesToAppend = _ref2.clonesToAppend,
      clonesToPrepend = _ref2.clonesToPrepend;

  for (var i = 0; i < clonesToAppend.length; i++) {
    particlesContainer.append(clonesToAppend[i]);
  }

  for (var _i2 = 0; _i2 < clonesToPrepend.length; _i2++) {
    particlesContainer.prepend(clonesToPrepend[_i2]);
  }
}
export function getClonesCount(_ref3) {
  var infinite = _ref3.infinite,
      particlesToShow = _ref3.particlesToShow,
      partialPageSize = _ref3.partialPageSize;
  var clonesCount = infinite ? {
    // need to round with ceil as particlesToShow, particlesToShow can be floating (e.g. 1.5, 3.75)
    head: Math.ceil(partialPageSize || particlesToShow),
    tail: Math.ceil(particlesToShow)
  } : {
    head: 0,
    tail: 0
  };
  return _objectSpread(_objectSpread({}, clonesCount), {}, {
    total: clonesCount.head + clonesCount.tail
  });
}